export default __webpack_public_path__ + "static/media/onion.f094c1c0.png";